import { isDevice, requestSync, useEngine } from '../engine/client';
import { agoLabel } from '../format';

/** 기기 모드의 동기화 상태 — 누르면 바로 동기화. PC(직결) 모드에서는 안내 문구만. */
export function SyncBadge({ compact = false }: { compact?: boolean }) {
  const { engine, sync } = useEngine();
  if (!isDevice) return compact ? null : <p className="sidebar-foot">PC 서버 직결 · 모든 기록은 이 컴퓨터에</p>;
  let label: string;
  let tone: string;
  if (engine === 'loading') {
    label = '엔진 준비 중';
    tone = 'accent';
  } else if (engine !== 'ready') {
    label = '엔진 오류';
    tone = 'bad';
  } else if (sync.state === 'syncing') {
    label = '동기화 중…';
    tone = 'accent';
  } else if (sync.state === 'offline') {
    label = `오프라인${sync.pending ? ` · 대기 ${sync.pending}` : ''}`;
    tone = 'warn';
  } else if (sync.pending) {
    label = `보낼 기록 ${sync.pending}`;
    tone = 'warn';
  } else {
    label = sync.lastSync ? `동기화됨 · ${agoLabel(sync.lastSync)}` : '동기화 전';
    tone = 'good';
  }
  return (
    <button type="button" className={`sync-badge ${tone} ${compact ? 'compact' : ''}`} onClick={requestSync} title="눌러서 지금 PC 와 동기화">
      <span className="sync-dot" aria-hidden="true" />
      {label}
    </button>
  );
}

/** 기기 엔진이 준비되기 전·실패했을 때 화면 맨 위 안내 */
export function EngineBanner() {
  const { engine, message } = useEngine();
  if (!isDevice || engine === 'ready') return null;
  if (engine === 'loading') {
    return <div className="engine-banner" role="status">{message || '엔진 준비 중'}… 처음 열 때는 몇 초 걸립니다</div>;
  }
  return (
    <div className="engine-banner bad" role="alert">
      {message || '엔진 오류'}
      <button type="button" className="btn btn-sm" onClick={() => location.reload()}>새로고침</button>
    </div>
  );
}
